import apiClient from '../middleware/apiClient';
import { CONSOLIDATED_OUTAGE_LOB, COTTON_CONSOLIDATED_OUTAGE_LOB } from '../helpers/apis';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { callApiWithFallback } from '../helpers/apiFallback';
import { kibanaLog } from '../helpers/logger';
// Fetch outage consolidated LOB
export const GET_OUTAGE_CONSOLIDATED_LOB = 'GET_OUTAGE_CONSOLIDATED_LOB';
export const GET_OUTAGE_CONSOLIDATED_LOB_SUCCESS = 'GET_OUTAGE_CONSOLIDATED_LOB_SUCCESS';
export const GET_OUTAGE_CONSOLIDATED_LOB_FAILURE = 'GET_OUTAGE_CONSOLIDATED_LOB_FAILURE';

function dispatchGetOutageConsolidatedLob(endpoint = CONSOLIDATED_OUTAGE_LOB) {
  return {
    type: GET_OUTAGE_CONSOLIDATED_LOB,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetOutageConsolidatedLobSuccess(outageConsolidatedLob) {
  return {
    type: GET_OUTAGE_CONSOLIDATED_LOB_SUCCESS,
    payload: outageConsolidatedLob,
  };
}

function dispatchGetOutageConsolidatedLobFailure(error) {
  return {
    type: GET_OUTAGE_CONSOLIDATED_LOB_FAILURE,
    payload: error,
  };
}

export const getConsolidatedOutageLob = () => async (dispatch, getState) => {
  if (getState().consolidatedOutage.requested) {
    return null;
  }
  try {
    let response;
    const { isAptV1Enabled, consolidatedOutageLobEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      // Use APT V1 API (100% Kotlin)
      kibanaLog('apt_v1_consolidated_outage_lob_api_called');
      response = await dispatch(
        dispatchGetOutageConsolidatedLob(COTTON_CONSOLIDATED_OUTAGE_LOB),
      ).payload;
    } else if (consolidatedOutageLobEnabled) {
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => dispatchGetOutageConsolidatedLob(COTTON_CONSOLIDATED_OUTAGE_LOB),
        () => dispatchGetOutageConsolidatedLob(CONSOLIDATED_OUTAGE_LOB),
        'consolidated_outage_lob',
      );
    } else {
      // Only call Ruby API
      response = await dispatch(dispatchGetOutageConsolidatedLob(CONSOLIDATED_OUTAGE_LOB)).payload;
    }

    return dispatch(dispatchGetOutageConsolidatedLobSuccess(response));
  } catch (error) {
    return dispatch(dispatchGetOutageConsolidatedLobFailure(error));
  }
};
